// @ts-nocheck
/*
 * Port of views/dashboard/ivr/IVR/nodes/RecordNode.js (309 lines).
 * BYTE-IDENTICAL — reactflow → @xyflow/react; AudioPreviewModel filename
 * typo → AudioPreviewModal (typo only in v1 filename, symbol unchanged).
 */
import React, { useContext, useState } from 'react';
import { Button, Form } from './_rbShim';
import { Handle, useReactFlow } from '@xyflow/react';
import { NodesContext } from '../provider/IvrContext';
import AudioPreviewModal from '../Helpers/AudioPreviewModal';
import { toast } from 'sonner';
import { Mic, Settings, Play, Trash2, Music } from 'lucide-react';
import IvrDrawer from '../Helpers/IvrDrawer';
import { triggerHandleConnect } from '../Helpers/utils';

const RecordNode = ({ data, id }: any) => {
  const { setNodes } = useReactFlow();

  const { updateNodeData, onRemove, audioList } = useContext(
    NodesContext,
  ) as any;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [playModalOpen, setPlayModalOpen] = useState(false);

  // ✅ derive from node data
  const action = data.action || {};
  const audioId = action.id || '';
  const audioUrl = action.audio || '';
  const audioName = action.name || '';
  const recordDuration = data.record_duration || '';
  const recordSilenceStop = data.recordSilenceStop ?? 0;
  const recordStopDtmf = data.recordStopDtmf ?? 'any_dtmf';

  const [draftAction, setDraftAction] = useState<any>(action);
  const [draftDuration, setDraftDuration] = useState<any>(recordDuration);
  const [draftSilenceStop, setDraftSilenceStop] = useState<any>(
    recordSilenceStop,
  );
  const [draftStopDtmf, setDraftStopDtmf] = useState<any>(recordStopDtmf);
  const [drawerPreview, setDrawerPreview] = useState<any>({
    open: false,
    url: '',
    name: '',
  });

  const updateNode = (updates: any) => {
    updateNodeData(id, updates);
  };

  const handleAudioChange = (e: any) => {
    const selected = audioList.find(
      (a: any) => a.id.toString() === e.target.value,
    );

    if (!selected) {
      setDraftAction({});
      return;
    }

    setDraftAction({
      type: 'record',
      id: selected.id,
      audio: Array.isArray(selected.prompt_url)
        ? selected.prompt_url[0]?.url || ''
        : selected.prompt_url || '',
      duration: selected.prompt_duration || '',
      name: selected.prompt_name,
    });
  };

  const validateForm = () => {
    const newErrors: any = {};

    if (!draftAction?.id) {
      newErrors.audio = 'Audio is required';
    }

    if (!draftDuration) {
      newErrors.record_duration = 'Record duration is required';
    }

    if (
      draftSilenceStop === '' ||
      draftSilenceStop === null ||
      draftSilenceStop === undefined
    ) {
      newErrors.recordSilenceStop = 'Silence stop is required';
    } else if (
      !/^\d+$/.test(String(draftSilenceStop)) ||
      Number(draftSilenceStop) < 0 ||
      Number(draftSilenceStop) > 10
    ) {
      newErrors.recordSilenceStop = 'Enter an integer from 0 to 10';
    }

    if (
      draftStopDtmf === '' ||
      draftStopDtmf === null ||
      draftStopDtmf === undefined
    ) {
      newErrors.recordStopDtmf = 'Stop DTMF is required';
    } else if (!/^(any_dtmf|\*|#)$/.test(String(draftStopDtmf))) {
      newErrors.recordStopDtmf = 'Must be Any DTMF, * or #';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validateForm()) return;

    updateNode({
      action: draftAction,
      record_duration: draftDuration,
      recordSilenceStop: Number(draftSilenceStop),
      recordStopDtmf: String(draftStopDtmf),
    });

    toast.success('Details updated successfully');
    setModalIsOpen(false);
  };

  const handleDurationChange = (e: any) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value < 600) {
      setDraftDuration(value);
    }
  };

  const handleSilenceStopChange = (e: any) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && Number(value) <= 10)) {
      setDraftSilenceStop(value);
    }
  };

  const handleStopDtmfChange = (e: any) => {
    setDraftStopDtmf(e.target.value);
  };

  const handleRemoveNode = () => {
    if (data.parent === 'gather Node' && data.idToRemove) {
      setNodes((nodes: any[]) =>
        nodes.map((node: any) => {
          if (!node.data.selectedHandles) return node;

          const updatedHandles = { ...node.data.selectedHandles };
          const updatedSmsData = { ...node.data.smsData };
          delete updatedHandles[data.idToRemove];
          if (updatedSmsData) {
            const parts = data.idToRemove.split('-');
            const handleIndex = parts[parts.length - 1];
            if (handleIndex) {
              const smsKey = `DTMF_${handleIndex}`;
              delete updatedSmsData[smsKey];
            }
          }
          return {
            ...node,
            data: {
              ...node.data,
              selectedHandles: updatedHandles,
              smsData: updatedSmsData,
            },
          };
        }),
      );
    }
    onRemove(id);
  };

  const openModal = () => {
    setDraftAction(action);
    setDraftDuration(recordDuration);
    setDraftSilenceStop(recordSilenceStop);
    setDraftStopDtmf(recordStopDtmf);
    setErrors({});
    // setModalIsOpen(true);
    setPlayModalOpen(true);
  };

  const handleClose = () => {
    setDraftAction(action);
    setDraftDuration(recordDuration);
    setDraftSilenceStop(recordSilenceStop);
    setDraftStopDtmf(recordStopDtmf);
    setErrors({});
    setModalIsOpen(false);
  };

  const renderListenBtn = (url: any, name: any) =>
    url ? (
      <button
        type="button"
        className="ivr-drawer-play-btn"
        title="Listen"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() =>
          setDrawerPreview({ open: true, url, name: name || 'Audio' })
        }
        style={{ marginLeft: 8 }}
      >
        ▶
      </button>
    ) : null;

  return (
    <div className="ivrn" style={{ '--node-color': '#0891b2' } as any}>
      <span
        className="ivrn-icon"
        style={{ background: '#0891b2', color: '#fff' }}
        onClick={triggerHandleConnect}
      >
        <Mic size={22} strokeWidth={2} />
      </span>
      <Handle
        type="target"
        position={'left' as any}
        style={{ background: '#0891b2', top: '65%' }}
      />
      <Handle
        type="source"
        position={'right' as any}
        style={{ background: '#0891b2' }}
      />

      <div className="ivrn-head">
        <span className="ivrn-title">Record</span>
      </div>
      <div className="ivrn-body">
        {audioName ? (
          <span className="ivrn-val">
            <Music size={10} style={{ marginRight: 4, flexShrink: 0 }} />
            {audioName}
          </span>
        ) : (
          <span className="ivrn-hint">Click ⚙ to configure audio</span>
        )}
      </div>

      <div className="ivrn-actions">
        <button
          className="ivrn-btn ivrn-btn--cfg"
          title="Configure"
          onClick={() => setModalIsOpen(true)}
        >
          <Settings size={14} strokeWidth={2} />
        </button>
        {audioUrl && (
          <button
            className="ivrn-btn ivrn-btn--play"
            title="Preview"
            onClick={openModal}
          >
            <Play size={14} strokeWidth={2} />
          </button>
        )}
        <button
          className="ivrn-btn ivrn-btn--del"
          title="Remove"
          onClick={handleRemoveNode}
        >
          <Trash2 size={14} strokeWidth={2} />
        </button>
      </div>

      <IvrDrawer
        show={modalIsOpen}
        onHide={handleClose}
        title="Record"
        subtitle="Configure call recording audio and duration."
        footer={
          <>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button onClick={handleSave}>Save</Button>
          </>
        }
      >
        <Form>
          <Form.Group>
            <Form.Label>Select Audio</Form.Label>
            <Form.Control
              as="select"
              value={draftAction?.id ? String(draftAction.id) : ''}
              onChange={handleAudioChange}
            >
              <option value="">Select Audio</option>
              {audioList.map((item: any) => (
                <option key={item.id} value={String(item.id)}>
                  {item.prompt_name}
                </option>
              ))}
            </Form.Control>
            {errors.audio && (
              <Form.Text className="text-danger">{errors.audio}</Form.Text>
            )}
          </Form.Group>
          {renderListenBtn(draftAction?.audio || '', draftAction?.name)}
          <Form.Group style={{ marginTop: '20px' }}>
            <Form.Label>Record Duration (seconds)</Form.Label>
            <Form.Control
              type="number"
              min="1"
              step="1"
              max={600}
              value={draftDuration}
              onChange={handleDurationChange}
              placeholder="Enter duration in seconds (Max 10 Mins)"
            />
            {errors.record_duration && (
              <Form.Text className="text-danger">
                {errors.record_duration}
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group style={{ marginTop: '20px' }}>
            <Form.Label>
              Silence Stop (0 - 10 seconds)
              <Form.Text className="text-danger"> *</Form.Text>
            </Form.Label>
            <Form.Control
              type="number"
              min="0"
              max="10"
              step="1"
              value={draftSilenceStop}
              onChange={handleSilenceStopChange}
              placeholder="Enter an integer from 0 to 10"
            />
            {errors.recordSilenceStop && (
              <Form.Text className="text-danger">
                {errors.recordSilenceStop}
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group style={{ marginTop: '20px' }}>
            <Form.Label>
              Stop DTMF<Form.Text className="text-danger"> *</Form.Text>
            </Form.Label>
            <Form.Control
              as="select"
              value={draftStopDtmf}
              onChange={handleStopDtmfChange}
            >
              <option value="any_dtmf">Any DTMF (0 - 9)</option>
              <option value="*">*</option>
              <option value="#">#</option>
            </Form.Control>
            {errors.recordStopDtmf && (
              <Form.Text className="text-danger">
                {errors.recordStopDtmf}
              </Form.Text>
            )}
          </Form.Group>
        </Form>
      </IvrDrawer>

      <AudioPreviewModal
        show={playModalOpen}
        onClose={() => setPlayModalOpen(false)}
        audioUrl={audioUrl}
        title={audioName}
      />

      <AudioPreviewModal
        show={drawerPreview.open}
        onClose={() =>
          setDrawerPreview({ open: false, url: '', name: '' })
        }
        audioUrl={drawerPreview.url}
        title={drawerPreview.name}
      />
    </div>
  );
};

export default RecordNode;
